export default "/themes/nutristopa/assets/img/plate.gif";